import React, { useEffect, useState } from "react";
import {
  ContainerCard,
  ContainerLabel,
  ContainerDetails,
} from "./tarjetaStyles";
import {
  formatoPrecio,
  calcularDescuento,
  calcularDescuentoNumero,
} from "../../utils/formatPrecio";
import { useDispatch } from "react-redux";
import { updatePlanComercial } from "../../redux/form/formSlice";

const Tarjeta = ({ item, index, actualizarSubtotal }) => {
  const [selectedPolitica, setSelectedPolitica] = useState(
    item?.data?.[0]?.politica?.id || null,
  );
  const [selectedProductName, setSelectedProductName] = useState("");
  const dispatch = useDispatch();

  // Único punto de escritura en redux: el efecto siguiente upserta el contrato
  // al montar y ante cada cambio de selección. Nada de addPlanComercial separado.

  // Auto-actualiza el subtotal y el plan en redux al montar y ante cada cambio de selección
  useEffect(() => {
    if (!item?.data?.length) return;

    const selectedData =
      item.data.length === 1
        ? item.data[0]
        : item.data.find((d) => d.politica?.id === selectedPolitica);

    if (!selectedData) return;

    const precio = selectedData.politica.precio;
    const descuento = selectedData.promocion?.descuentos?.[0]?.descuento || 0;
    const precioFinalDescuento = calcularDescuentoNumero(precio, descuento);

    actualizarSubtotal(index, precioFinalDescuento);

    dispatch(
      updatePlanComercial({
        id: index,
        productoId: selectedData.producto.id,
        politicaId: selectedData.politica.id,
        promocionId: selectedData.promocion.id,
      }),
    );
  }, [selectedPolitica, item, index, dispatch, actualizarSubtotal]);

  const handlePoliticaChange = (event) => {
    const value = Number(event.target.value);
    setSelectedPolitica(value);
  };

  useEffect(() => {
    if (!item?.data?.length) return;
    let productName = "";
    if (item.data.length === 1) {
      productName = item.data[0].producto.nombre;
    } else {
      const selectedProduct = item.data.find(
        (valor) => selectedPolitica === valor.politica.id,
      );
      if (selectedProduct) {
        productName = selectedProduct.producto.nombre;
      }
    }
    setSelectedProductName(productName);
  }, [item.data, selectedPolitica]);

  if (!item?.data?.length) return null;

  return (
    <ContainerCard>
      <ContainerDetails>
        <ContainerLabel>
          {item.data.length === 1 ? (
            <label
              id="cardTitle"
              key={item.data[0].producto.id}
              value={item.data[0].producto.id}
            >
              {item.data[0].producto.nombre}
            </label>
          ) : (
            item.data.map((valor) =>
              selectedPolitica === valor.politica.id ? (
                <label id="cardTitle" key={valor.id} value={valor.producto.id}>
                  {valor.producto.nombre}
                </label>
              ) : null,
            )
          )}
        </ContainerLabel>
        <ContainerLabel>
          {item.data.length === 1 ? (
            <label
              id="cardSubtitle"
              key={item.data[0].politica.id}
              value={item.data[0].politica.id}
            >
              {item.data[0].politica.nombre}
            </label>
          ) : (
            <select
              name="Politica"
              onChange={handlePoliticaChange}
              value={selectedPolitica}
            >
              {item.data.map((valor) => (
                <option
                  id="cardSubtitle"
                  key={valor.id}
                  value={valor.politica.id}
                >
                  {valor.politica.nombre}
                </option>
              ))}
            </select>
          )}
        </ContainerLabel>
        <ContainerLabel>
          {item.data.length === 1 ? (
            <label
              id="cardSubtitle"
              key={item.data[0].id}
              value={item.data[0].promocion.nombre}
            >
              {item.data[0].promocion.nombre
                ? item.data[0].promocion.nombre
                : "No tiene promoción"}
            </label>
          ) : (
            item.data.map((valor) =>
              valor.politica.id === selectedPolitica ? (
                <label
                  id="cardSubtitle"
                  key={valor.id}
                  value={valor.promocion.nombre}
                >
                  {valor.promocion.nombre
                    ? valor.promocion.nombre
                    : "No tiene promoción"}
                </label>
              ) : null,
            )
          )}
        </ContainerLabel>
        <ContainerLabel>
          {item.data.length === 1
            ? (() => {
                const precio = item.data[0].politica.precio;
                const descuento =
                  item.data[0].promocion?.descuentos?.[0]?.descuento || 0;
                const precioFinalDescuento = calcularDescuento(
                  precio,
                  descuento,
                );

                return (
                  <label id="cardPrice" key={item.data[0].id}>
                    {descuento > 0 ? (
                      <>
                        <span
                          style={{
                            textDecoration: "line-through",
                            opacity: 0.6,
                          }}
                        >
                          {formatoPrecio(precio)}
                        </span>{" "}
                        <span style={{ color: "#f7f3f3" }}>
                          {precioFinalDescuento}
                        </span>
                      </>
                    ) : (
                      <span>{formatoPrecio(precio)}</span>
                    )}
                  </label>
                );
              })()
            : item.data.map((valor) =>
                valor.politica.id === selectedPolitica
                  ? (() => {
                      const precio = valor.politica.precio;
                      const descuento =
                        valor.promocion?.descuentos?.[0]?.descuento || 0;
                      const precioFinalDescuento = calcularDescuento(
                        precio,
                        descuento,
                      );

                      return (
                        <label id="cardPrice" key={valor.id}>
                          {descuento > 0 ? (
                            <>
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  opacity: 0.6,
                                }}
                              >
                                {formatoPrecio(precio)}
                              </span>{" "}
                              <span style={{ color: "#f7f3f3" }}>
                                {precioFinalDescuento}
                              </span>
                            </>
                          ) : (
                            <span>{formatoPrecio(precio)}</span>
                          )}
                        </label>
                      );
                    })()
                  : null,
              )}
        </ContainerLabel>
      </ContainerDetails>
    </ContainerCard>
  );
};

export default Tarjeta;
